import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Api from '../config/Api';

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			permissions: ''
		}
	}

	componentWillMount() {
		var self = this;
		Api.parseToken(this.state.token, function(response) {
			self.setState({
				permissions: response.permissions
			});
		});
	}

    render() {
    	return(
    		<div className="dashboard">
				<div>
					<ul className="dashboardLinks">
	    				<li>
	    					<Link to="/files" className="br10 sh1 anim-1">
	    						<span className="fas fa-file"></span>
	    						Files
	    					</Link>
	    				</li>
						{/*
	    				<li>
	    					<Link to="/egfr" className="br10 sh1 anim-1">
	    						<span className="fas fa-calculator"></span>
	    						eGFR
	    					</Link>
						</li>
						*/}
	    				{this.state.permissions === 'admin' ?
		    				<li>
		    					<Link to="/users" className="br10 sh1 anim-1">
		    						<span className="fas fa-user-plus"></span>
		    						Users
		    					</Link>
		    				</li>
		    			: null}
	    				<li>
	    					<Link to="/account" className="br10 sh1 anim-1">
	    						<span className="fas fa-user"></span>
	    						My Account
	    					</Link>
	    				</li>
	    				<li>
	    					<Link to="/logout" className="br10 sh1 anim-1">
	    						<span className="fas fa-sign-out-alt"></span>
	    						Logout
	    					</Link>
	    				</li>
	    			</ul>
				</div>
    		</div>
    	);
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js